import { useRef } from 'react';

import { Menu } from '@components/common/dropdown';
import { useToggleDropdown } from '@hooks/common';

import MoreSolid from '@assets/svgs/MoreSolid.svg';
import type { MenuItem } from '@steadioTypes/dropdown';

type MoreVertIconButtonProps = {
  menuList: MenuItem[];
  onClickOptionButton?: (event: React.MouseEvent) => void;
};

export default function MoreVertIconButton({
  menuList,
  onClickOptionButton,
}: MoreVertIconButtonProps) {
  const optionButtonRef = useRef<HTMLButtonElement>(null);
  // useToggleDropdown에서 리턴된 openOption으로 메뉴 open/close 처리됨
  const openOption = useToggleDropdown(optionButtonRef);

  return (
    <div className="relative flex items-center">
      <button type="button" ref={optionButtonRef} onClick={onClickOptionButton}>
        <MoreSolid className="w-[24px] h-[24px] content_quaternary" />
      </button>

      {openOption && <Menu menuList={menuList} top={36} />}
    </div>
  );
}
